module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av77-a760f3a0ad034c7bfe58a4258d0c7683.jpg";